import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, Col, FormGroup, Row } from "reactstrap";

import {
  Btn,
  DefaultButton,
  H3,
  MUIIcons,
  P,
} from "../../../../../../AbstractElements";
import { LEARNER_STATUS, STATUS_200 } from "../../../../../../Api/constants";
import BorderTabs from "../../../../../../CommonElements/BorderTabs";
import Divider from "../../../../../../CommonElements/Divider";
import FilterSliderModal from "../../../../../../CommonElements/FilterSliderModal";
import FixedFooter from "../../../../../../CommonElements/FixedFooter";
import LabelTooltip from "../../../../../../CommonElements/LabelTooltip";
import CommonModal from "../../../../../../CommonElements/Modal";
import MultiFileUpload from "../../../../../../CommonElements/MultiFileUpload/MultiFileUpload";
import MultiSelectDropdown from "../../../../../../CommonElements/MultiSelectDropdown";
import SliderModal from "../../../../../../CommonElements/SliderModal";
import VerticalDivider from "../../../../../../CommonElements/VericalDivider";
import VerticalTabs from "../../../../../../CommonElements/VerticalTabs";
import EmployeeList from "../../../../../../container/EmployeeList";
import EnrolledUserGroups from "../../../../../../container/EnrolledUserGroups";
import UserDetailsCard from "../../../../../../container/UserDetailsCard";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../ReduxToolkit/Hooks";
import { bulkUploadUsers } from "../../../../../../ReduxToolkit/Reducers/AssessmentCatlogSlice";
import {
  getLearningPlanById,
  updateLearningPlan,
} from "../../../../../../ReduxToolkit/Reducers/LearningPlanMaster";
import {
  getFilterRolesList,
  getSbuList,
  getUserMasterList,
  setUserMasterListToInitial,
} from "../../../../../../ReduxToolkit/Reducers/MasterSlice";
import {
  getUserGroupById,
  getUserGroupList,
} from "../../../../../../ReduxToolkit/Reducers/UserGroupSlice";
import { getDownloadableUrl } from "../../../../../../ReduxToolkit/Reducers/UserSlice";
import { dynamicImage } from "../../../../../../Service";
import {
  AddUsersTitle,
  Confirm,
  ConfirmAddUserLearningPlanHeader,
  Done,
  Download,
  EndDate,
  Enter,
  JobRole,
  Mobile,
  PleaseAddUsersOrUserGroupsToGroup,
  RM,
  SBU,
  Search,
  SearchForUsersOrGroups,
  Select,
  StartDate,
  Upload,
  UploadFile,
  UserGroups,
  Users,
  UseThisTemplate,
} from "../../../../../../utils/Constant";
import {
  formatDate,
  learningPlanAddUserTabs,
  showToast,
  userAndGroupsTab,
} from "../../../../../../utils/helper/helper";

const LearningPlanAddUserDetails = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [flushData, setFlushData] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("select_user");
  const [basicTab, setBasicTab] = useState("users");
  const { roleOnFilter, sbuList, userMasterList } = useAppSelector(
    state => state.master
  );
  const { urlList } = useAppSelector(state => state.user);
  const [uploadFile, setUploadFile] = useState([]);
  const [scheduleDates, setScheduleDates] = useState({
    start_date: new Date(),
    end_date: new Date(),
  });
  const [sliderModalOpen, setSliderModalOpen] = useState(false);
  const { learningPlanById } = useAppSelector(
    state => state.learningPlanMaster
  );
  const { userGroups } = useAppSelector(state => state.userGroup);
  const [preSelectedUsers, setPreSelectedUsers] = useState([]);
  const [preSelectedUserGroups, setPreSelectedUserGroups] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [usersListMap, setUsersListMap] = useState({});
  const [userGroup, setUserGroup] = useState([]);
  const [roleFilterList, setRoleFilterList] = useState([]);
  const [sbuFilterList, setSbuFilterList] = useState([]);
  const [selectedFilterValues, setSelectedFilterValues] = useState({});
  const [defaultFilterValues, setDefaultFilterValues] = useState({});
  const [userCardDetailIds, setUserCardDetailIds] = useState([]);
  const [userCardDetail, setUserCardDetail] = useState([]);
  const [userGroupCardDetailIds, setUserGroupCardDetailIds] = useState([]);
  const [userGroupCardDetail, setUserGroupCardDetail] = useState([]);
  const location = useLocation();
  const { learningPlanId, enrolledUsersIds, enrolledUserGroupIds, type } =
    location.state || [];
  const { userGroupById } = useAppSelector(state => state.userGroup);

  useEffect(() => {
    getUserGroup();
    dispatch(getDownloadableUrl());
  }, [dispatch]);

  useEffect(() => {
    if (learningPlanId) {
      dispatch(getLearningPlanById({ id: learningPlanId }));
    }
  }, [dispatch, learningPlanId]);

  useEffect(() => {
    if (learningPlanById?.duration) {
      const startDate = new Date();
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(startDate);
      if (Number(learningPlanById.duration) > 0) {
        endDate.setDate(
          endDate.getDate() + (Number(learningPlanById.duration) - 1)
        );
      }
      endDate.setHours(0, 0, 0, 0);

      setScheduleDates({
        start_date: startDate,
        end_date: endDate,
      });
    }
  }, [learningPlanById]);

  useEffect(() => {
    if (type) {
      setBasicTab(type);
    }
  }, [type]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const getUserGroup = async () => {
    await dispatch(getUserGroupList());
  };

  useEffect(() => {
    dispatch(
      getUserMasterList({
        roleId: null,
        sbuId: null,
        type: LEARNER_STATUS?.toString(),
      })
    );
    dispatch(getFilterRolesList());
    dispatch(getSbuList());
  }, [dispatch]);

  useEffect(() => {
    const value = [];
    const nameMap = {};
    if (userMasterList) {
      userMasterList?.users?.forEach((item: any) => {
        nameMap[item?.id] = item;
        value.push({
          name: item?.id,
          label: `${item?.user_name} - ${item?.employee_code || "-"} - ${item?.email || "-"}`,
          value: `${item?.user_name} - ${item?.employee_code || "-"} - ${item?.email || "-"}`,
        });
      });
    }
    setUsersListMap(nameMap);
    setUsersList(value);
  }, [userMasterList]);

  useEffect(() => {
    const groups = [];
    if (userGroups) {
      userGroups?.user_groups?.forEach((item: any) => {
        groups.push({
          name: item?.id?.toString(),
          label: item?.name?.toString(),
          value: item?.name?.toString(),
        });
      });
    }
    setUserGroup(groups);
  }, [userGroups]);

  useEffect(() => {
    const value = [];
    if (roleOnFilter) {
      roleOnFilter?.job_role?.forEach(item => {
        value.push({
          name: item?.id,
          label: item?.name,
          value: item?.name,
        });
      });
    }
    setRoleFilterList(value);
  }, [roleOnFilter]);

  useEffect(() => {
    const value = [];
    if (sbuList) {
      sbuList?.sbu?.forEach(item => {
        value.push({
          name: item?.id,
          label: item?.name,
          value: item?.name,
        });
      });
    }
    setSbuFilterList(value);
  }, [sbuList]);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  const handleDone = async (values: { [key: string]: string[] }) => {
    if (values["role"] || values["sbu"]) {
      dispatch(setUserMasterListToInitial());
      await dispatch(
        getUserMasterList({
          roleId: values["role"]?.toString(),
          sbuId: values["sbu"]?.toString(),
          type: LEARNER_STATUS?.toString(),
        })
      );
    }
  };

  const handleClear = async () => {
    setUsersList([]);
    setPreSelectedUsers([]);
    setUserCardDetail([]);
    setUserCardDetailIds([]);
    await dispatch(
      getUserMasterList({
        roleId: null,
        sbuId: null,
        type: LEARNER_STATUS?.toString(),
      })
    );
    setSelectedFilterValues({});
    setDefaultFilterValues({});
  };

  const setMultiDropdownData = (value: any[]) => {
    const usersMap = [];

    usersList?.forEach((element: any) => {
      if (value.includes(element.name)) {
        usersMap.push({
          name: element.name,
          value: element.label,
          label: element.label,
        });
      }
    });
    setPreSelectedUsers(usersMap);
  };

  const setMultiDropdownGroupData = (value: any[]) => {
    const groupMap = [];

    userGroup?.forEach((element: any) => {
      if (value.includes(element.name)) {
        groupMap.push({
          name: element.name,
          value: element.label,
          label: element.label,
        });
      }
    });
    setPreSelectedUserGroups(groupMap);
  };

  const onUploadFile = async () => {
    const postData = new FormData();
    uploadFile.forEach(file => {
      postData.append("file", file[0]);
    });
    const ids = [];
    const enrolled = await dispatch(bulkUploadUsers({ file: postData }));
    const userData = [];
    if (enrolled?.payload?.users) {
      setFlushData(true);
      const existingUserIds = userCardDetail.map(user => user.id);
      enrolled?.payload?.users?.map(item => {
        if (
          !enrolledUsersIds.includes(item.id) &&
          !existingUserIds.includes(item.id)
        ) {
          ids.push(item?.id);
          userData.push({
            imagePath:
              item?.profile_url || dynamicImage("profile/user_profile.png"),
            name: item.user_name,
            detail: "",
            empId: item?.employee_code,
            phoneNumber: item?.phone,
            id: item.id,
            sbuName: item?.sbu,
            rmName: item?.mapped_rm?.[0]?.name,
            rmPhone: item?.mapped_rm?.[0]?.rm_phone,
          });
        }
      });
    }
    setUploadFile([]);
    setUserCardDetailIds([...userCardDetailIds, ...ids]);
    setUserCardDetail([...userCardDetail, ...userData]);
  };

  const getChangedDate = date => {
    const newDate = new Date(date);
    if (Number(learningPlanById.duration) > 0) {
      newDate.setDate(
        newDate.getDate() + (Number(learningPlanById.duration) - 1)
      );
    }
    return newDate;
  };

  const handleDateChange = (name: string, date: Date) => {
    setScheduleDates(prevState => ({
      ...prevState,
      end_date: name === "start_date" ? getChangedDate(date) : date,
      start_date: name === "start_date" ? date : prevState?.start_date,
    }));
  };

  const onSubmitData = async () => {
    if (userCardDetailIds.length === 0 && userGroupCardDetailIds.length === 0) {
      showToast(PleaseAddUsersOrUserGroupsToGroup, "error");
      return;
    }

    const payload: any = {
      id: learningPlanId,
      users: userCardDetailIds || [],
      user_groups: userGroupCardDetailIds || [],
      start_date: formatDate(scheduleDates?.start_date),
      end_date: formatDate(scheduleDates?.end_date),
    };

    let res = null;
    res = await dispatch(
      updateLearningPlan({ payload: payload, type: "edit_learning_plan_users" })
    );

    if (res?.payload?.status_code === STATUS_200) {
      return navigate(
        `${process.env.PUBLIC_URL}/master-data/learning-plan-detail?id=${learningPlanId}`
      );
    }
  };

  const toggleSliderModal = () => {
    setSliderModalOpen(!sliderModalOpen);
  };

  return (
    <div className="page-body">
      <SliderModal
        isOpen={sliderModalOpen}
        toggle={() => {
          toggleSliderModal();
        }}
      >
        <>
          <H3 className="mt-3">{userGroupById?.name}</H3>
          <P className="text-muted mt-2">
            {userGroupById?.users?.length} {Users}
          </P>
          <Divider />
          <>
            {userGroupById?.users?.map(items => {
              return (
                <>
                  <div className="mt-2">
                    <UserDetailsCard
                      userDetails={{
                        id: items,
                        name: usersListMap
                          ? usersListMap[items]?.user_name
                          : null,
                        empId: usersListMap
                          ? usersListMap[items]?.employee_code
                          : null,
                        mobile: usersListMap
                          ? usersListMap[items]?.phone
                          : null,
                      }}
                      showGap={false}
                    />
                    <Row className="text-muted mt-3">
                      <Col
                        lg="4"
                        md="4"
                        sm="12"
                        xs="12"
                        className="d-flex gap-2"
                      >
                        <MUIIcons iconName="BadgeOutlined" size={20} />
                        <span>
                          {SBU}:
                          <span>
                            {usersListMap
                              ? usersListMap[items]?.sbu || "-"
                              : null}
                          </span>
                        </span>
                      </Col>
                      <Col className="d-flex gap-2">
                        <MUIIcons iconName="PersonOutline" size={20} />
                        <span className="ms-2">
                          <div>
                            {RM}{" "}
                            <span className="text-dark">
                              {usersListMap
                                ? usersListMap[items]?.mapped_rm?.[0]?.name ||
                                  "-"
                                : null}
                            </span>
                          </div>
                          <div>
                            {Mobile}:{" "}
                            {usersListMap
                              ? usersListMap[items]?.mapped_rm?.[0]?.rm_phone ||
                                "-"
                              : null}
                          </div>
                        </span>
                      </Col>
                    </Row>
                  </div>
                  <Divider />
                </>
              );
            })}
          </>
        </>
      </SliderModal>
      <CommonModal
        sizeTitle={Confirm}
        isOpen={isModalOpen}
        toggle={toggleModal}
        backdrop="static"
        size="lg"
        showFooter
        onPrimaryBtnClick={onSubmitData}
        primaryBtnText={Confirm}
      >
        {ConfirmAddUserLearningPlanHeader}
      </CommonModal>
      <Card>
        <CardBody>
          <H3 className="mt-2">{AddUsersTitle}</H3>
          <Divider />
          <div className="mt-3">
            <BorderTabs
              showCard={false}
              tabs={learningPlanAddUserTabs}
              activeTab={activeTab}
              handleTabClick={handleTabClick}
            />
            {activeTab === "select_user" && (
              <Row className="mt-4">
                <Col lg="2">
                  <VerticalTabs
                    tabItems={userAndGroupsTab}
                    activeTab={basicTab}
                    setActiveTab={setBasicTab}
                  />
                </Col>
                <Col>
                  <VerticalDivider />
                </Col>
                <Col lg="9">
                  {basicTab === "users" && (
                    <>
                      <Row className="mb-3">
                        <Col lg="8" md="8" sm="11" xs="11">
                          <LabelTooltip
                            label={Users}
                            tooltipText={`${Select} ${Users}`}
                            important={false}
                          />

                          <MultiSelectDropdown
                            onChange={setMultiDropdownData}
                            options={usersList?.filter(
                              item =>
                                !userCardDetailIds?.includes(item?.name) &&
                                !enrolledUsersIds?.includes(item?.name)
                            )}
                            placeholder={SearchForUsersOrGroups}
                            defaultSelected={preSelectedUsers}
                            onBlurDropdown={values => {
                              const selected = [];
                              values?.forEach(item => {
                                selected.push(item?.name);
                              });

                              const userData = [];
                              const userIds = [];
                              userMasterList?.users?.forEach((element: any) => {
                                if (selected.includes(element.id)) {
                                  userIds.push(element.id);
                                  userData.push({
                                    imagePath:
                                      element?.profile_url ||
                                      dynamicImage("profile/user_profile.png"),
                                    name: element.user_name,
                                    detail: "",
                                    empId: element?.employee_code,
                                    phoneNumber: element?.phone,
                                    id: element.id,
                                    sbuName: element?.sbu,
                                    rmName: element?.mapped_rm?.[0]?.name,
                                    rmPhone: element?.mapped_rm?.[0]?.rm_phone,
                                  });
                                }
                              });
                              setUserCardDetailIds([
                                ...userCardDetailIds,
                                ...userIds,
                              ]);
                              setUserCardDetail([
                                ...userCardDetail,
                                ...userData,
                              ]);
                              setPreSelectedUsers([]);
                            }}
                          />
                        </Col>
                        <Col lg="1" md="1" sm="1" xs="1">
                          <div className="filter-margin">
                            <FilterSliderModal
                              dropdowns={[
                                {
                                  label: JobRole,
                                  key: "role",
                                  tooltipText: `${Select} ${JobRole}`,
                                  options: roleFilterList,
                                  isMultiSelect: true,
                                },
                                {
                                  label: SBU,
                                  key: "sbu",
                                  tooltipText: `${Select} ${SBU}`,
                                  options: sbuFilterList,
                                  isMultiSelect: true,
                                },
                              ]}
                              selectedFilterValues={selectedFilterValues}
                              defaultFilterValues={defaultFilterValues}
                              setSelectedFilterValues={setSelectedFilterValues}
                              setDefaultFilterValues={setDefaultFilterValues}
                              onDone={handleDone}
                              onClear={handleClear}
                            />
                          </div>
                        </Col>
                      </Row>
                      <EmployeeList
                        onParticipantDelete={id => {
                          const updatedIds = userCardDetailIds?.filter(
                            item => item !== id
                          );
                          setUserCardDetailIds(updatedIds);

                          const updatedUsers = userCardDetail.filter(
                            user => user.id !== id
                          );
                          setUserCardDetail(updatedUsers);
                        }}
                        userCardWithDetail={userCardDetail}
                        showCard={false}
                        deleteParticipant
                      />
                    </>
                  )}
                  {basicTab === "user_groups" && (
                    <>
                      <Row className="mb-3">
                        <Col lg="8" md="8" sm="11" xs="11">
                          <LabelTooltip
                            label={UserGroups}
                            tooltipText={`${Select} ${UserGroups}`}
                            important={false}
                          />

                          <MultiSelectDropdown
                            onChange={setMultiDropdownGroupData}
                            options={userGroup?.filter(
                              item =>
                                !userGroupCardDetailIds.includes(item?.name) &&
                                !enrolledUserGroupIds.includes(item?.name)
                            )}
                            placeholder={`${Search} ${UserGroups}`}
                            defaultSelected={preSelectedUserGroups}
                            onBlurDropdown={values => {
                              const selected = [];
                              values?.forEach(item => {
                                selected.push(item?.name);
                              });

                              const userData = [];
                              const userIds = [];
                              userGroups?.user_groups?.forEach(
                                (element: any) => {
                                  if (
                                    selected.includes(element.id.toString())
                                  ) {
                                    userIds.push(element.id.toString());
                                    userData.push({
                                      id: element?.id?.toString(),
                                      name: element?.name,
                                      no_of_users: element?.no_of_users,
                                      no_of_learning_plan:
                                        element?.no_of_learning_plan,
                                    });
                                  }
                                }
                              );
                              setUserGroupCardDetailIds([
                                ...userGroupCardDetailIds,
                                ...userIds,
                              ]);
                              setUserGroupCardDetail([
                                ...userGroupCardDetail,
                                ...userData,
                              ]);
                              setPreSelectedUserGroups([]);
                            }}
                          />
                        </Col>
                      </Row>

                      {userGroupCardDetail?.map(item => {
                        return (
                          <div key={item?.id} className="mt-1">
                            <EnrolledUserGroups
                              heading={item?.name}
                              noOfGroups={item?.no_of_users}
                              onDeleteClick={() => {
                                const updatedIds =
                                  userGroupCardDetailIds?.filter(
                                    items => items !== item?.id
                                  );
                                setUserGroupCardDetailIds(updatedIds);

                                const updatedUsers = userGroupCardDetail.filter(
                                  user => user.id !== item?.id
                                );
                                setUserGroupCardDetail(updatedUsers);
                              }}
                              toggleSliderModal={async () => {
                                await dispatch(
                                  getUserGroupById({ id: item?.id })
                                );
                                toggleSliderModal();
                              }}
                              showDelete
                            />
                            <Divider />
                          </div>
                        );
                      })}
                    </>
                  )}
                </Col>
              </Row>
            )}
            {activeTab === "upload_document" && (
              <>
                <div className="mt-3">
                  <LabelTooltip
                    label={UploadFile}
                    tooltipText={UploadFile}
                    important
                  />
                  <div className="d-flex gap-4">
                    <P>{UseThisTemplate}</P>
                    <a
                      href={urlList?.data?.templates?.email_template || ""}
                      download
                    >
                      <P className="primary-text-color">{Download}</P>
                    </a>
                  </div>
                  <MultiFileUpload
                    flushData={flushData}
                    accept=".csv"
                    multiple={false}
                    onFileChange={(file, status) => {
                      if (flushData) {
                        setFlushData(false);
                      }
                      if (status === "removed") {
                        if (uploadFile)
                          setUploadFile(prevDocuments =>
                            prevDocuments.filter(
                              item => item[0].name !== file.name
                            )
                          );
                      } else if (status === "done" && file) {
                        setUploadFile(prevDocuments => [
                          ...(Array.isArray(prevDocuments)
                            ? prevDocuments
                            : []),
                          [file],
                        ]);
                      }
                    }}
                  />
                  {uploadFile?.length > 0 && (
                    <div className="mt-3">
                      {" "}
                      <Btn color="primary" onClick={onUploadFile}>
                        {Upload}
                      </Btn>
                    </div>
                  )}
                </div>
                <Row className="mt-3">
                  <Col lg="2"></Col>
                  <Col>
                    <EmployeeList
                      onParticipantDelete={id => {
                        const updatedIds = userCardDetailIds?.filter(
                          item => item !== id
                        );
                        setUserCardDetailIds(updatedIds);

                        const updatedUsers = userCardDetail.filter(
                          user => user.id !== id
                        );
                        setUserCardDetail(updatedUsers);
                      }}
                      userCardWithDetail={userCardDetail}
                      showCard={false}
                      deleteParticipant
                    />
                  </Col>
                </Row>
              </>
            )}
          </div>
          <Divider />
          <Row className="mt-1">
            <Col sm="12" lg="6">
              <FormGroup>
                <LabelTooltip
                  label={StartDate}
                  tooltipText={StartDate}
                  important
                />
                <div className={"w-100"}>
                  <DatePicker
                    selected={scheduleDates?.start_date}
                    onChange={(date: Date | null) =>
                      handleDateChange("start_date", date)
                    }
                    minDate={new Date()}
                    placeholderText={`${Enter} ${StartDate}`}
                    className={"w-100 form-control"}
                    dateFormat="dd-MM-yyyy"
                    disabledKeyboardNavigation={true}
                    onKeyDown={e => e.preventDefault()}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
              </FormGroup>
            </Col>
            <Col sm="12" lg="6">
              <FormGroup>
                <LabelTooltip label={EndDate} tooltipText={EndDate} important />
                <div className={"w-100"}>
                  <DatePicker
                    selected={scheduleDates?.end_date}
                    onChange={(date: Date | null) =>
                      handleDateChange("end_date", date)
                    }
                    minDate={scheduleDates?.start_date || new Date()}
                    placeholderText={`${Enter} ${EndDate}`}
                    className={"w-100 form-control"}
                    dateFormat="dd-MM-yyyy"
                    disabledKeyboardNavigation={true}
                    onKeyDown={e => e.preventDefault()}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <FixedFooter>
        <DefaultButton color="primary" onClick={toggleModal}>
          {Done}
        </DefaultButton>
      </FixedFooter>
    </div>
  );
};

export default LearningPlanAddUserDetails;
